import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen({ onLoadingComplete }) {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => onLoadingComplete(), 500);
          }, 500);
          return 100;
        }
        return prev + Math.random() * 15 + 5;
      });
    }, 150);

    return () => clearInterval(timer);
  }, [onLoadingComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 bg-gradient-to-br from-[#e8e9eb] via-white to-[#e8e9eb] z-50 flex flex-col items-center justify-center"
        >
          {/* Logo Video Animation */}
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex flex-col items-center mb-8"
          >
            <div className="relative w-60 h-48 md:w-60 md:h-60 lg:w-72 lg:h-72">
              <video
                src="videos/شعار زان 2.webm"
                autoPlay
                loop
                muted
                className="w-full h-full object-cover rounded-full"
                playbackrate={1}
              />

              {/* Optional subtle glow behind video */}
              <div className="absolute inset-0 bg-gradient-radial from-[#141d3c]/30 via-[#ee9805]/20 to-transparent rounded-full blur-2xl scale-150 -z-10" />
            </div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 1 }}
              className="text-center mt-6"
            >
              <h1 className="font-mono text-2xl font-bold text-[#141d3c] mb-2">
                ZAN DIGITAL MARKETING
              </h1>
              <h2 className="text-xl text-gray-600 tracking-widest uppercase font-cairo font-bold">
شـركة زان التسـويـقية الرقميـة              </h2>
            </motion.div>
          </motion.div>

          {/* Progress Bar */}
          <motion.div
            initial={{ width: 0, opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden"
          >
            <motion.div
              className="h-full bg-gradient-to-r from-[#141d3c] to-[#ee9805] rounded-full"
              initial={{ width: "0%" }}
              animate={{ width: `${Math.min(progress, 100)}%` }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            />
          </motion.div>

          {/* Loading Text */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.7 }}
            className="text-sm text-gray-500 mt-4 font-medium"
          >
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
